import { Paper, Typography } from '@mui/material';

export default function Metric({ label, value }: { label: string; value: number }) {
  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h4" fontWeight={800}>{value}</Typography>
      <Typography color="text.secondary">{label}</Typography>
    </Paper>
  );
}
